import { Typography } from "@mui/material";
import { CustomBreadCrumbs } from "../../components";
import Grid from "@mui/material/Unstable_Grid2";
import { LPMapGrid } from "../../components/LPMapGrid";
import { useDealerLinks } from "./hook";

export const DealerLinks = (): JSX.Element => {
    const { isLoading, lpAccounts } = useDealerLinks();

    return (
        <Grid container spacing={3}>
            <Grid xs={12}>
                <CustomBreadCrumbs path="Home/Dealer Links" />
            </Grid>

            <Grid
                xs={12}
                container
                spacing={2}
                alignItems="center"
                justifyContent="space-between"
            >
                <Grid xs={12} md={7}>
                    <Typography
                        variant="h4"
                        sx={{ color: "#1BA0E9", fontWeight: 600, fontSize: 25 }}
                        textAlign={{ xs: "center", md: "left" }}
                    >
                        Dealer Links
                    </Typography>
                    <Typography
                        sx={{ fontSize: 14, mt: 1 }}
                        textAlign={{ xs: "center", md: "left" }}
                    >
                        Browse available dealer links
                    </Typography>
                </Grid>
            </Grid>

            <Grid xs={12}>
                <LPMapGrid accounts={lpAccounts} loading={isLoading} />
            </Grid>
        </Grid>
    );
};